import { SortDefinition } from '@shared/models/sort-definition';

export interface TrigrammeTypeCertificationState {
  paginator: { pageNb: number; pageSize: number };
  sort: SortDefinition;
}

export const initialState: TrigrammeTypeCertificationState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sort: { direction: '+', nom: 'code' },
};
